<template>
  <div class="core">
    <div class="layui-fluid">
      <div>
        <div class="layui-form layui-card-header layuiadmin-card-header-auto">
          <div class="layui-form-item">
            <div class="layui-inline">
              IP地址
            </div>
            <div class="layui-inline">
              <input
                class="layui-input"
                autocomplete="off"
                v-model="t_log.queryObject['IP:2']"
                placeholder="请输入IP地址"
              />
            </div>
            <div class="layui-inline">
              用户id
            </div>
            <div class="layui-inline">
              <input
                class="layui-input"
                autocomplete="off"
                v-model="t_log.queryObject['USERID:2']"
                placeholder="请输入用户id"
              />
            </div>
            <!-- <div class="layui-inline">
              <layui-tableselect
                ref="tableSelect"
                table-name="DB_DOCUMENT"
                input-width="200px"
                table-width="500px"
                text-field="S_ORIGINAL_NAME"
                value-field="DOCUMENT_ID"
                queryFields="S_ORIGINAL_NAME"
                v-model="t_log.queryObject.tableSelect"
                tip="请选择一个"
                :sort="['CREATE_TIME:DESC']"
                :page-size="15"
                :page-range="6"
                :page-options="[15, 25, 50, 100]"
                style="width:400px"
              >
                <div>
                  <div radio="true"></div>
                  <div field="S_ORIGINAL_NAME" title="文件名称"></div>
                  <div field="CREATE_TIME" title="上传时间"></div>
                </div>
              </layui-tableselect>
            </div> -->
            <div class="layui-inline">
              <button class="layui-btn layuiadmin-btn-list" @click="$refs.t_log.load()" title="查询">查询</button>
              <button class="layui-btn" @click="$refs.t_log.reset()" title="重置">重置</button>
            </div>
          </div>
        </div>
        <div class="layui-card-body">
          <div class="layui-table-body layui-table-main">
            <layui-table
              ref="t_log"
              table-name="DB_LOG"
              :sort="['LOGID:DESC']"
              :page-size="15"
              :page-range="6"
              :page-options="[15, 25, 50, 100]"
              select-fields="CREATE_DATETIME,IP,LOGDESC,LOGTYPE,USERID,BROWSER,OS"
              @table-event-detail="
                $refs.logForm.openWin()
                $refs.logForm.setEditRow($event.data)
              "
            >
              <div>
                <!-- 开启复选框 -->
                <div field="_NUMBER" title="序号" width="60"></div>
                <div field="IP" title="IP地址"></div>
                <div field="USERID" title="用户id"></div>
                <div field="LOGDESC" title="描述"></div>
                <div field="LOGTYPE" title="类型"></div>
                <div field="BROWSER" title="浏览器"></div>
                <div field="OS" title="操作系统"></div>
                <div field="CREATE_DATETIME" title="登录时间"></div>
                <div fixed="right" width="150" align="center" toolbar title="操作">
                  <script type="text/html">
                    <a class="layui-btn-xs" lay-event="detail">查看</a>
                  </script>
                </div>
              </div>
            </layui-table>
          </div>
        </div>
        <layui-form ref="logForm">
          <template slot-scope="{ scope }">
            <div class="layui-form" style="padding: 20px 30px 0 0;">
              <div class="layui-form-item">
                <label class="layui-form-label"> 创建时间：</label>
                <div class="layui-input-inline">
                  <input
                    type="text"
                    v-model="scope.editRow.CREATE_DATETIME"
                    autocomplete="off"
                    class="layui-input"
                    name="CREATE_DATETIME"
                    disabled="disabled"
                  />
                </div>
              </div>
              <div class="layui-form-item">
                <label class="layui-form-label"> IP地址：</label>
                <div class="layui-input-inline">
                  <input
                    type="text"
                    v-model="scope.editRow.IP"
                    autocomplete="off"
                    class="layui-input"
                    name="IP"
                    disabled="disabled"
                  />
                </div>
              </div>
              <div class="layui-form-item">
                <label class="layui-form-label"> 描述：</label>
                <div class="layui-input-inline">
                  <input
                    type="text"
                    v-model="scope.editRow.LOGDESC"
                    autocomplete="off"
                    class="layui-input"
                    name="LOGDESC"
                    disabled="disabled"
                  />
                </div>
              </div>
              <div class="layui-form-item">
                <label class="layui-form-label"> 类型：</label>
                <div class="layui-input-inline">
                  <input
                    type="text"
                    v-model="scope.editRow.LOGTYPE"
                    autocomplete="off"
                    class="layui-input"
                    name="LOGTYPE"
                    disabled="disabled"
                  />
                </div>
              </div>
              <div class="layui-form-item">
                <label class="layui-form-label"> 操作系统：</label>
                <div class="layui-input-inline">
                  <input
                    type="text"
                    v-model="scope.editRow.OS"
                    autocomplete="off"
                    class="layui-input"
                    name="OS"
                    disabled="disabled"
                  />
                </div>
              </div>
              <div class="layui-form-item">
                <label class="layui-form-label"> 浏览器：</label>
                <div class="layui-input-inline">
                  <input
                    type="text"
                    v-model="scope.editRow.BROWSER"
                    autocomplete="off"
                    class="layui-input"
                    name="BROWSER"
                    disabled="disabled"
                  />
                </div>
              </div>
              <div class="layui-form-item">
                <label class="layui-form-label"> 用户ID：</label>
                <div class="layui-input-inline">
                  <input
                    type="text"
                    v-model="scope.editRow.USERID"
                    autocomplete="off"
                    class="layui-input"
                    name="USERID"
                    disabled="disabled"
                  />
                </div>
              </div>

              <div class="layui-form-item">
                <label for="L_repass" class="layui-form-label"> </label>
                <button class="layui-btn" @click="$refs.logForm.close()">关闭</button>
              </div>
            </div>
          </template>
        </layui-form>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Log',
  data() {
    return {
      t_log: {
        checkedRows: 0,
        queryObject: { _test: 1 }
      }
    }
  },
  mounted() {
    this.t_log = this.$refs.t_log
  //  this.t_log.queryObject.tableSelect = 322;
  }
}
</script>



// WEBPACK FOOTER //
// src/components/ywpt/log/Log.vue